import { ColumnMeta, columnTypeToDataType } from '../../types';
import { createFieldDefinition, FieldDefinition, FieldPrimitiveType } from './field-definition.schema';

export function columnMetaToFieldDefinition(cm: ColumnMeta): FieldDefinition {
  return createFieldDefinition({
    key: cm.path || cm.name,
    displayName: cm.displayName,
    description: cm.description || undefined,
    type: columnTypeToDataType(cm.type) as FieldPrimitiveType,
    format: cm.formatting || undefined,
    sortOrder: cm.tableOrder ?? 0,
    isActive: cm.visible !== false,
    createdAt: cm.createdAt,
    updatedAt: cm.updatedAt,
  });
}

export function fieldDefinitionToColumnMeta(fd: FieldDefinition, source: ColumnMeta): ColumnMeta {
  return {
    ...source,
    displayName: fd.displayName,
    description: fd.description ?? source.description,
    tableOrder: fd.sortOrder,
    visible: fd.isActive,
    formatting: fd.format ?? source.formatting,
  };
}
